import { z } from 'zod'

// ─── Inquiry Form Schema ──────────────────────────────────────────────────────

export const inquiryFormSchema = z
  .object({
    name: z.string().min(2, 'Name must be at least 2 characters'),
    email: z.string().email('Please enter a valid email address'),
    phone: z.string().optional(),
    cabinId: z.string().optional(),
    checkIn: z.string().min(1, 'Check-in date is required'),
    checkOut: z.string().min(1, 'Check-out date is required'),
    guests: z.number().int().min(1, 'At least 1 guest required').max(10, 'Maximum 10 guests'),
    message: z.string().max(1000, 'Message must be under 1000 characters').optional(),
  })
  .refine((data) => new Date(data.checkOut) > new Date(data.checkIn), {
    message: 'Check-out must be after check-in',
    path: ['checkOut'],
  })

export type InquiryFormSchema = z.infer<typeof inquiryFormSchema>

// ─── Contact Form Schema ──────────────────────────────────────────────────────

export const contactFormSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Please enter a valid email address'),
  subject: z.string().optional(),
  message: z.string().min(10, 'Message must be at least 10 characters').max(2000),
})

export type ContactFormSchema = z.infer<typeof contactFormSchema>

// ─── API Response Schema ──────────────────────────────────────────────────────

export const inquiryResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({ id: z.string() }),
})

export const galleryResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(
    z.object({
      id: z.string(),
      r2Key: z.string(),
      url: z.string(),
      thumbUrl: z.string(),
      title: z.string().optional(),
      altText: z.string(),
      category: z.enum(['treehouse', 'landscape', 'interior', 'dining', 'activities']),
      sortOrder: z.number(),
      isFeatured: z.boolean(),
      width: z.number().optional(),
      height: z.number().optional(),
    })
  ),
})
